module.exports = __webpack_public_path__ + "static/media/sara.d7bddb70.jpeg";